import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-party-cream font-sans text-party-ink selection:bg-party-rose selection:text-white" data-id="element-0" data-mp="33oriy2lrxzq1">
      <noscript data-id="element-1" data-mp="3dkl42adk71jf">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3dl4mrtb19tyi" />
      </noscript>

      <Hero data-id="element-3" data-mp="stc9c7v436ph" />
      <main data-id="element-4" data-mp="st2i6gybyti7">
        <ProblemSection data-id="element-5" data-mp="swqc3h7othxg" />
        <SolutionSection data-id="element-6" data-mp="36hzxgtw5a5z" />
        <BonusesSection data-id="element-7" data-mp="35oxut5vn8u6" />
        <BenefitsSection data-id="element-8" data-mp="34x0pdwmt31s" />
        <OfferSection data-id="element-9" data-mp="38b5stwojqcx" />
        <GuaranteeSection data-id="element-10" data-mp="3ud1f186rfma3" />
        <Testimonials data-id="element-11" data-mp="3ubrhck3tkg3z" />
        <FAQSection data-id="element-12" data-mp="3ucjc5sple9t7" />
        <FinalCTA data-id="element-13" data-mp="3uf5hrmsxaf8s" />
      </main>
      <Footer data-id="element-14" data-mp="d57fv4288kjl" />
      {showPurchasePopup && <PurchasePopup data-id="element-15" data-mp="d45ti3frgbmk" />}
    </div>;
}